export const RESIDENTIAL_COMPLEXES_TOOLTIP_TOPIC = 'residentialComplexesTooltip';
